export default "__VITE_ASSET__D57hIMoG__"